import { makeAutoObservable } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import { ToastType } from '../components/generics/toast';

export interface ToastItem {
  id: string;
  type: ToastType;
  message: string;
  duration?: number;
}

class ToastStore {
  toasts: ToastItem[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  addToast(type: ToastType, message: string, duration = 5000): string {
    const id = uuidv4();
    const toast: ToastItem = {
      id,
      type,
      message,
      duration
    };
    
    this.toasts.push(toast);
    return id;
  }

  removeToast(id: string): void {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
  }

  clearAllToasts(): void {
    this.toasts = [];
  }

  /**
   * Méthodes d'aide pour ajouter différents types de toasts
   */
  success(message: string, duration = 5000): string {
    return this.addToast('success', message, duration);
  }

  error(message: string, duration = 5000): string {
    return this.addToast('error', message, duration);
  }

  info(message: string, duration = 5000): string {
    return this.addToast('info', message, duration);
  }

  warning(message: string, duration = 5000): string {
    return this.addToast('warning', message, duration);
  }
}

const toastStore = new ToastStore();
export default toastStore;
